// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationCheckDouble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m6.393 16.2.298-.298 1.4 1.4-1.345 1.344a.5.5 0 0 1-.707 0l-4.893-4.893a.5.5 0 0 1 0-.707l.693-.693a.5.5 0 0 1 .707 0zm11.646-8.846-7.134 7.134-1.4-1.4 7.134-7.134a.5.5 0 0 1 .707 0l.693.692a.5.5 0 0 1 0 .708zm-10.682 5 3.846 3.846L21.449 5.954a.5.5 0 0 1 .707 0l.693.692a.5.5 0 0 1 0 .708L11.556 18.646a.5.5 0 0 1-.707 0l-4.892-4.893a.5.5 0 0 1 0-.707l.692-.693a.5.5 0 0 1 .708 0z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNavigationCheckDouble;
